// @flow

import * as React from 'react';

import { connect } from 'react-redux';
import { superpathjoin } from 'superpathjoin';

import { selectFromConfig } from '@gandi/redux-config';
import { type TranslatorProps, localeSelector } from '@gandi/translate';
import {
  Base,
  OrderedList,
  Text,
  TypoListItem as ListItem,
  TypoListTitle as ListTitle,
  TypoListHelp as ListHelp,
} from '@gandi/ui';

import { Card, CardLabel, Action } from '@gandi/ui/deprecated';

import { selectWhoisUrl } from 'src/modules/config';

import type { FullState } from '../../types';

type Item = {
  title: string,
  help?: React.Node,
};

const selectPublicUrl = selectFromConfig<string>(
  'app.layout.urls.public_site',
  'https://www.gandi.net',
);

const itemList: (
  __: TranslatorProps['__'],
  whoisUrl: string,
  tldsUrl: string,
) => Array<Item> = (__, whoisUrl, tldsUrl) => [
  {
    title: __('Your domain does not expire in the next few days'),
  },
  {
    title: __(
      'It has been registered with or transferred to its current registrar for at least 60 days',
    ),
    help: (
      <Text
        dangerouslySetInnerHTML={__(
          'This is a general rule, you may want to' +
            ' <a href="%(tldsUrl)s">check the specific rules</a>' +
            " for your domain's extension",
          { withHTML: true, tldsUrl },
        )}
      />
    ),
  },
  {
    title: __('Protection against transfer is disabled on your domain'),
  },
  {
    title: __('Owner and administrative email addresses are up to date'),
  },
];

const renderItem = (item: Item, index: number) => (
  <ListItem key={index}>
    <ListTitle size="base">{item.title}</ListTitle>
    {
      // $FlowFixMe[sketchy-number-and]
      item.help && <ListHelp>{item.help}</ListHelp>
    }
  </ListItem>
);

type StateProps = {
  locale: string,
  whoisUrl: string,
  publicUrl: string,
};

type OwnProps = {
  translator: TranslatorProps,
};

type Props = StateProps & OwnProps;

const TransferAlertBox = (props: Props) => {
  const {
    translator: { __ },
    locale,
    whoisUrl,
    publicUrl,
  } = props;

  const docLink = __(
    'https://docs.gandi.net/en/domain_names/transfer/index.html',
  );

  return (
    <Card
      footer={
        <Action icon="arrowRight" variant="block" href={docLink}>
          {__('More info on domain transfer')}
        </Action>
      }
    >
      <CardLabel>
        <Base tagName="h2" weight="semibold" size="big" color="base">
          {__('To be able to transfert a domain to gandi, please check:')}
        </Base>
      </CardLabel>
      <OrderedList>
        {itemList(
          __,
          superpathjoin(whoisUrl, locale),
          superpathjoin(publicUrl, locale, 'tlds'),
        ).map(renderItem)}
      </OrderedList>
    </Card>
  );
};

const mapStateToProps = (state: FullState): StateProps => ({
  locale: localeSelector(state),
  whoisUrl: selectWhoisUrl(state),
  publicUrl: selectPublicUrl(state),
});

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(mapStateToProps)(TransferAlertBox);
